import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route, extract } from '@app/core';
import {ShoppingPromotionComponent} from '@app/shopping-promotion/shopping-promotion.component';
import {ShoppingPromotionNfFormComponent} from '@app/shopping-promotion-nf-form/shopping-promotion-nf-form.component';
import {ShoppingPromotionLotteryComponent} from '@app/shopping-promotion-lottery/shopping-promotion-lottery.component';

const routes: Routes = Route.withShell([
  {
    path: 'shopping/:shoppingId/promotion/:promotionId', component: ShoppingPromotionComponent, data: {
      title: extract('Promoção')
    }
  },
  {
    path: 'shopping/:shoppingId/promotion/:promotionId/lottery', component: ShoppingPromotionLotteryComponent, data: {
      title: extract('Sorteio')
    }
  },
  {
    path: 'shopping/:shoppingId/promotion/:promotionId/nf', component: ShoppingPromotionNfFormComponent, data: {
      title: extract('Notas Fiscais')
    }
  }
]);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ShoppingPromotionRoutingModule { }



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-promotion/shopping-promotion-routing.module.ts